import { t } from '@/utils/i18n'
import { Checkbox, Button } from 'antd-mobile'
import { cal, utils, apis } from '@/utils'
import { useCorpSettingStore, useCartStore } from '@/stores'
import styles from './index.module.less'

const { moneyFormat } = cal
const { orderApi } = apis
const { to } = utils

interface IProps {
  className: string
  corpId: string
  isCheckAll: boolean
  loading?: boolean
  onCheckAll: (data: { isCheckAll: boolean }) => void
  onOrderConfirm: () => void
}

const SummaryBar = (props: IProps) => {
  const { isCheckAll, corpId, loading, onCheckAll, onOrderConfirm } =
    props
  const { corpSetting } = useCorpSettingStore()
  const { cart, setCart } = useCartStore()

  function checkAllChange(value: boolean) {
    onCheckAll({ isCheckAll: value })
    handleCheckAll(value)
  }

  // 请求接口，勾选全部
  async function handleCheckAll(isCheckAll: boolean) {
    const [err, res] = await to(
      orderApi.shoppingCartSelectAll({
        cartId: cart.cartId,
        corpId,
        selected: Number(isCheckAll),
      })
    )

    if (err || !res) {
      return
    }

    const resData = res.data || {}
    const { amount, productCount, quantity } = resData
    setCart({
      ...cart,
      amount,
      productCount,
      quantity,
    })
  }

  return (
    <div className={styles['summary-bar-container']}>
      <Checkbox value="" checked={isCheckAll} onChange={checkAllChange}>
        {t('全选')}
      </Checkbox>
      <div className={styles['total-item']}>
        <div className={styles['total-amount']}>
          <span>{t('合计：')}</span>
          <span className={styles['money-text']}>
            <span className={styles['symbol']}>
              {corpSetting.currencySymbol}
            </span>
            {moneyFormat(cart.amount, corpSetting.pricePrecision)}
          </span>
        </div>
        <div className={styles['total-num']}>
          {t('已选：')}
          {moneyFormat(cart.productCount, corpSetting.qualityPrecision)}
        </div>
      </div>
      <Button
        color="primary"
        className={styles['btn-primary']}
        loading={loading}
        onClick={onOrderConfirm}
      >
        {t('结账')}
      </Button>
    </div>
  )
}

export default SummaryBar
